/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.networkSettings', [])
    .factory('networkSettingsService', NetworkSettingsService)
    .name;

/*@ngInject*/
function NetworkSettingsService($http, $q) {

    var service = {
        getNetworkSettings: getNetworkSettings,
        getMulticastGroupNetworkSettings: getMulticastGroupNetworkSettings,
        saveNetworkSettings: saveNetworkSettings,
        saveMulticastGroupNetworkSettings: saveMulticastGroupNetworkSettings,
        createDefaultNetworkSettings: createDefaultNetworkSettings,
        createDefaultMulticastGroupNetworkSettings: createDefaultMulticastGroupNetworkSettings
    }

    return service;

    function getNetworkSettings (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/networkSettings/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getMulticastGroupNetworkSettings (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/multicastGroupNetworkSettings/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveNetworkSettings (networkSettings) {
        var deferred = $q.defer();
        var url = '/api/networkSettings';
        $http.post(url, networkSettings).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveMulticastGroupNetworkSettings (networkSettings) {
        var deferred = $q.defer();
        var url = '/api/multicastGroupNetworkSettings';
        $http.post(url, networkSettings).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function createDefaultNetworkSettings() {
        return {
            rxWindow: 0,
            rxDelay: 0,
            fcntCheck: true,
            rx2DataRate: -1,
            rx1DataRateOffset: 0,
            adrInterval: 1,
            installationMargin: 0,
            pingSlotDr: 0,
            pingSlotFreq: 0,
            beaconFreq: 0
        };
    }

    function createDefaultMulticastGroupNetworkSettings() {
        return {
            rxcDataRate: -1,
            rxcFrequency: 0
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/api/network-settings.service.js